import PalletCard from './components/pallets/PalletCard'
import PalletPrint from './components/pallets/PalletPrint'
import { usePalletActions, usePalletState } from './stores/palletStore'
import {
  useScanProgressActions,
  useScanProgressState
} from './stores/scanProgressStore'

import ConfirmDialog from '@/components/common/ConfirmDialog'
import LoadingSpinner from '@/components/common/LoadingSpinner'
import { palletV2Service } from '@/services'
import { useUIStore } from '@/stores/useUIStore'

const PendingPallets: React.FC = () => {
  const { loading, palletList, palletsGroup } = useScanProgressState()
  const { printVisible, dismantleVisible, palletPrintData, palletId } =
    usePalletState()
  const { closePrintDialog, closeDismantleConfirm } = usePalletActions()
  const { fetchProgress } = useScanProgressActions()
  const { showSuccess } = useUIStore()

  const handleDismantSubmit = async () => {
    if (!palletId) return
    const { success, message } = await palletV2Service.dismantlePallet(palletId)
    if (success) {
      closeDismantleConfirm()
      showSuccess(message)
      fetchProgress()
    }
  }

  if (loading) {
    return (
      <div>
        <LoadingSpinner />
      </div>
    )
  }

  if (palletList.length === 0) {
    return (
      <div className="flex-1 flex items-center justify-center">
        <div className="text-center">
          <div className="text-gray-500 text-lg">暂无托盘</div>
        </div>
      </div>
    )
  }

  return (
    <div className="h-full flex flex-col px-6 overflow-y-auto">


      {/* 托盘列表 - 按分提单分组 */}
      <div className="flex-1 overflow-y-auto">
        {palletsGroup.map((group) => (
          <div key={group.houseBillId} className="border-b border-gray-200 last:border-b-0">
            {/* 分提单标题 */}
            <div className="bg-gray-50 px-4 py-2 border-b border-gray-200">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <span className="font-medium text-gray-800 text-sm">
                    {group.houseBlNumber}
                  </span>
                  <span className="text-xs text-gray-500">
                    {group.pallets.length}个托盘 • {group.pallets.reduce((sum, p) => sum + p.totalBoxes, 0)}箱
                  </span>
                </div>
              </div>
            </div>

            {/* 该分提单下的托盘列表 */}
            <div>
              {group.pallets.map((pallet) => (
                <PalletCard key={pallet.id} pallet={pallet} />
              ))}
            </div>
          </div>
        ))}
      </div>

      {palletPrintData && (
        <PalletPrint
          data={palletPrintData}
          visible={printVisible}
          onClose={() => closePrintDialog()}
        />
      )}

      <ConfirmDialog
        isOpen={dismantleVisible}
        title="确认拆托"
        message="拆托后托盘将被删除，此操作不可恢复！确认要继续吗？"
        confirmText="确认拆托"
        cancelText="取消"
        onConfirm={() => handleDismantSubmit()}
        onCancel={() => closeDismantleConfirm()}
        isDangerous={true}
      />
    </div>
  )
}

export default PendingPallets
